import { render, staticRenderFns } from "./Ruecklagenkonto.vue?vue&type=template&id=5ba8afd1&"
import script from "./Ruecklagenkonto.vue?vue&type=script&lang=js&"
export * from "./Ruecklagenkonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports